import { Component, HostListener, Inject, PLATFORM_ID, SimpleChanges } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '@modules/shared/services/seo.service';
import { MetaTagConfig } from '@modules/shared/models/common/seo.model';

import { isPlatformBrowser } from '@angular/common';
import { Page } from '@framework/base';
import { environment } from '@app/env/environment';
import "@mux/mux-player";
import { storyActions } from '@modules/story/store/actions';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
import { Actions, ofType } from '@ngrx/effects';
// import "@mux/mux-player";

@Component({
  selector: 'app-embed-video-url',
  templateUrl: './embed-video-url.component.html',
  styleUrls: ['./embed-video-url.component.css']
})
export class EmbedVideoComponent extends Page {
  // Private variables
  public idOrSlug: number | string;
 public isBrowser:boolean;
  quillData:string;
  quillModule = {
    toolbar:[{}],
  }
  storyDetailSubscription: any;
  renderURL:any;
  thumbnailURL: any
  storyId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: Object,
    private router:Router,
    private actions$: Actions,
    private store$: Store<CoreState>,
    private seoService:SeoService

  ) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);
    // this.checkIsAuthenticated();

    this.captureParams();

  }

  // Life cycle hook
  protected onInit(): void {
    // this.startImport();
     this.store$.dispatch(new storyActions.Select(this.storyId, true, null, null,false));
    this.subscribe();

   
  }
  protected onDestroy(): void {
    this.unsubscribe();
    // this.destoryScript();
    this.seoService.clearMetaTags();
  }
  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {

  }

  /**
   * this method is to update meta tag according to story detail
   */
  private addMetaTags(): void {
    const config: MetaTagConfig = new MetaTagConfig();
      config.title = `Embed`;
      config.description = 'EmbedGS';
      config.alt=  'Embed';
      config.image =this.thumbnailURL[0]
   
    config.url = 'https://'+environment.customUrl+this.router.url;
  
    config.castLarge = true;
    this.seoService.updateMetaTags(config);
  }


  // public startImport(){
  //   $("#hippo-video-delivery-scripts").empty();
  //   let injectScript = document.createElement('script');
  //   injectScript.type = 'text/javascript';
  //   injectScript.async = true;
  //   injectScript.src = 'https://hippo-embed-scripts.s3.amazonaws.com/video-delivery-embed.js'
  //   document.getElementById('hippo-video-delivery-scripts').appendChild(injectScript);
  // }


  // destoryScript(){
  //   $("#hippo-video-delivery-scripts").empty();
  // }

  private subscribe() {

 this.storyDetailSubscription=   this.actions$
    .pipe(
      ofType<storyActions.LoadDetailSuccess>(
        storyActions.ActionTypes.LOAD_DETAIL_SUCCESS
      )
    )
    .subscribe((action) => {
  if(action.data && action.data.id >0){
    this.thumbnailURL = action.data.media
    .filter(m => m.type === "video/mp4" && m.source === this.idOrSlug)
    .map(m => m.thumbnail_url ? m.thumbnail_url : `https://image.mux.com/${m.source}/thumbnail.jpg`);
    this.renderURL = this.thumbnailURL[0]
    if(!this.isBrowser){
      this.addMetaTags();
    }
  }

    
  
      // ⚡ You can do further logic using action if required
   
  
    });
  

  }

  private unsubscribe() {

  }

  private captureParams() {
   this.idOrSlug = this.activatedRoute.snapshot.paramMap.get('idOrSlug');
   this.storyId =  this.activatedRoute.snapshot.paramMap.get('storyId');
  }





  // Public function
 
  getUrl(media){
    if(media && media.thumbnail_url){
      return media.thumbnail_url
    }
    else{
     return 'https://image.mux.com/'+media.source+'/thumbnail.jpg'
    }
  }

}



